/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundTimeForwardIcon64Regular = forwardRef('ArrowRoundTimeForwardIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M41.38 11a23 23 0 1 0 10.952 31.753 1.5 1.5 0 0 1 2.652 1.403A26 26 0 1 1 54 18.144V8a1.5 1.5 0 0 1 3 0v13.25A2.75 2.75 0 0 1 54.25 24H41.5a1.5 1.5 0 0 1 0-3h10.699a23 23 0 0 0-10.818-10Z" })));
});
